angular.module('picmonicng').factory('ClassificationService', [
  'ClassificationsResource',
  '$filter',
  function (ClassificationsResource, $filter) {
    return {
      classifications: ClassificationsResource.query(),
      getClassificationById: function (id) {
        var classification = $filter('filter')(this.classifications, { classification_id: id }, true);
        return classification ? classification[0] : null;
      },
    };
  },
]);
